import { CrudService } from './crud.service';
import { CarBrandCreateUpdateDto as DTO } from '@shared/dto/car-brand';
import { CarBrandResource as Res } from '@shared/resources/car-brand';

export class CarBrandService extends CrudService<DTO, DTO, Res> {
  protected pathPrefix(): string {
    return 'car-brands';
  }
}
